import React from 'react';
import PropTypes from 'prop-types';
import StyledCVSFieldContainer from './styled/cvsFieldContainer';
import StyledCancelIcon from './styled/cancelIcon';
export default function FileFieldCell(_ref) {
  var value = _ref.value;

  if (value) {
    return value;
  }

  return React.createElement(StyledCVSFieldContainer, null, "Not assigned yet", React.createElement(StyledCancelIcon, null));
}
FileFieldCell.propTypes = {
  value: PropTypes.string.isRequired
};